import _ from 'lodash';

const events = {
    "$W_INTERACTION_PREVIEW": {
        "endpoint": "platform",
        "params": {
            "evid": 150,
            "src": 79
        }
    },
    "$W_INTERACTION_SITE": {
        "endpoint": 'platform-viewer',
        "params": {
            "evid": 136,
            "src": 79
        }
    }
};

function getBIEvent(eventName) {
    return _.get(events, eventName);
}

export default getBIEvent;